module.exports = __webpack_public_path__ + "img/Tacco_e_Intertacco_DX.5c5a5d7c.png";